import { render, staticRenderFns } from "./modal-approval-offset.vue?vue&type=template&id=f067e95a&"
import script from "./modal-approval-offset.vue?vue&type=script&lang=js&"
export * from "./modal-approval-offset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports